import createSocket from '../../createSocket';
import authReducer from './auth.reducer';
import contextReducer from './context.reducer';
import pointsReducer from './points.reducer';
import eventsReducer from './events.reducer';
import leaderboardsReducer from './leaderboards.reducer';
import pagesReducer from './pages.reducer';
import statsReducer from './stats.reducer';
import clientReducer from './clients.reducer';
import adminReducer from './admins.reducer';
import auditReducer from './audit.reducer';
import attendeesReducer from './attendees.reducer';
import attendeeReducer from './attendee.reducer';
import eventSyncsReducer from './eventSyncs.reducer';
import announcementsReducer from './announcements.reducer';
import postsReducer from './posts.reducer';
import mediaReducer from './media.reducer';
import libraryReducer from './library.reducer';
import agendaReducer from './agenda.reducer';
import kudosReducer from './kudos.reducer';
import connectionsReducer from './connections.reducer';
import checkinsReducer from './checkins.reducer';
import groupsReducer from './groups.reducer';
import locationsReducer from './locations.reducer';
import photoBoothMediaReducer from './photoBoothMedia.reducer';
import pinnedReducer from './pinned.reducer';
import notificationPreferencesReducer from './notificationPreferences.reducer';
import widgetsReducer from './widget.reducer';
import aiPhotoboothReducer from './aiPhotobooth.reducer';
import { combineReducers } from 'redux';
import podcastsReducer from './podcasts.reducer';

const socket = createSocket();

const rootReducer = combineReducers({
	auth: authReducer,
	audit: auditReducer,
	agenda: agendaReducer,
	context: contextReducer,
	points: pointsReducer,
	connections: connectionsReducer,
	checkins: checkinsReducer,
	events: eventsReducer,
	pages: pagesReducer,
	leaderboards: leaderboardsReducer,
	stats: statsReducer,
	clients: clientReducer,
	admins: adminReducer,
	attendees: attendeesReducer,
	attendee: attendeeReducer,
	eventSyncs: eventSyncsReducer,
	announcements: announcementsReducer,
	posts: postsReducer,
	eventMedia: mediaReducer,
	photoBoothMedia: photoBoothMediaReducer,
	library: libraryReducer,
	kudosBadgesList: kudosReducer,
	groups: groupsReducer,
	locations: locationsReducer,
	pinnedItems: pinnedReducer,
	notificationPreferences: notificationPreferencesReducer,
	widgets: widgetsReducer,
	aiPhotobooths: aiPhotoboothReducer,
	podcasts: podcastsReducer,
	ws: (state = { socket }) => state,
});

export default rootReducer;
